import { render, staticRenderFns } from "./consulta_campo_check.vue?vue&type=template&id=6a0c126e&scoped=true&"
import script from "./consulta_campo_check.vue?vue&type=script&lang=js&"
export * from "./consulta_campo_check.vue?vue&type=script&lang=js&"
import style0 from "./consulta_campo_check.vue?vue&type=style&index=0&id=6a0c126e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c126e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
